import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

type ProfileStats = {
  studyDays: number;
  vocabularyCount: number;
  watchedVideos: number;
};

export function useProfileStats(userId?: string) {
  return useQuery({
    queryKey: ["profile-stats", userId],
    enabled: !!userId,
    queryFn: async (): Promise<ProfileStats> => {
      const [{ count: vocabularyCount, error: vocabError }, learningRes] = await Promise.all([
        supabase.from("vocabulary").select("id", { count: "exact", head: true }).eq("user_id", userId),
        supabase
          .from("learning_records")
          .select("video_id,updated_at,watch_duration,progress")
          .eq("user_id", userId),
      ]);

      if (vocabError) throw vocabError;
      if (learningRes.error) throw learningRes.error;

      const rows = learningRes.data || [];

      const watchedSet = new Set<string>();
      const daySet = new Set<string>();

      for (const r of rows as any[]) {
        if (r?.video_id) watchedSet.add(String(r.video_id));

        const watchDuration = Number(r?.watch_duration || 0);
        const progress = Number(r?.progress || 0);
        if (watchDuration > 0 || progress > 0) {
          const d = new Date(r.updated_at);
          if (!Number.isNaN(d.getTime())) {
            const key = d.toISOString().slice(0, 10);
            daySet.add(key);
          }
        }
      }

      return {
        studyDays: daySet.size,
        vocabularyCount: vocabularyCount || 0,
        watchedVideos: watchedSet.size,
      };
    },
  });
}

